/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RoadFeatureRequest } from '../models/RoadFeatureRequest';
import type { RoadFeatureRequestWithBruksklasse } from '../models/RoadFeatureRequestWithBruksklasse';
import type { RoadFeatures } from '../models/RoadFeatures';
import type { RoadFeaturesWithBruksklasse } from '../models/RoadFeaturesWithBruksklasse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RoadFeatureService {

    /**
     * Get list of roadfeatures associated with a set of nvdbreferencelinks
     * @returns RoadFeatures 
     * @throws ApiError
     */
    public static roadFeatureGetRoadFeatures({
roadFeatureRequest,
}: {
roadFeatureRequest: RoadFeatureRequest,
}): CancelablePromise<RoadFeatures> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RoadFeature/roadFeatures',
            body: roadFeatureRequest,
        });
    }

    /**
     * Get list of roadfeatures with bruksklasse associated with a set of nvdbreferencelinks
     * @returns RoadFeaturesWithBruksklasse 
     * @throws ApiError
     */
    public static roadFeatureGetRoadFeaturesWithBruksklasse({
roadFeatureRequest,
}: {
roadFeatureRequest: RoadFeatureRequestWithBruksklasse,
}): CancelablePromise<RoadFeaturesWithBruksklasse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/RoadFeature/roadFeaturesWithBruksklasse',
            body: roadFeatureRequest,
        });
    }

}
